import { LegalClientEntity, LegalClientBranchEntity } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import { DialogStateProps } from 'libs/ui';
import { AddDialogForm } from 'modules/client/common/components';

import { LegalClientAddBranchSections } from '../components';
import { useLegalClientAddBranch } from '../hooks';

interface Props extends DialogStateProps {
  legalClient: LegalClientEntity;
  onSuccess: (legalClientBranch: LegalClientBranchEntity) => void;
}

export const LegalClientAddBranchDialogFeature = ({
  legalClient,
  isOpen,
  onClose,
  onSuccess,
}: Props) => {
  const {
    countries,
    countriesLoading,
    initialValues,
    validationSchema,
    submitLoading,
    onSubmit,
  } = useLegalClientAddBranch(legalClient, onSuccess);

  const { t } = useTranslation();

  return (
    <AddDialogForm
      initialValues={initialValues}
      isOpen={isOpen}
      submitLoading={submitLoading}
      title={t('client.legal.legalClientBranch.addDialog.title')}
      validationSchema={validationSchema}
      onClose={onClose}
      onSubmit={onSubmit}
    >
      <LegalClientAddBranchSections
        countries={countries ?? []}
        countriesLoading={countriesLoading}
      />
    </AddDialogForm>
  );
};
